const e = "검색란 지우기", l = "옵션 선택", a = {
  clearSearch: e,
  selectPlaceholder: l,
  "Select.InputSearch.Value:placeholder": "검색",
  "Select.InputSearch.Value:aria-label": "검색"
};
export {
  e as clearSearch,
  a as default,
  l as selectPlaceholder
};
